import { Link } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { mapContentTypesToLocaleId } from '@fhnw/components/GlobalSearch/lib';
import GlobalSearchBreadcrumbs from '@fhnw/components/GlobalSearch/GlobalSearchBreadcrumbs';
import { mapTokenToLabel } from '@fhnw/components/Blocks/SolarSearch/lib';
import { mapItemToTeaserProps } from '@fhnw/components/Blocks/Listing/variations/mapItemToTeaserProps';
import { processDateAndLocation } from '@fhnw/components/Teaser/Teaser';
import { useVocab } from '@fhnw/components/VocabContext/useVocab';

type NewsProps = {
  closeGlobalSearch: () => void;
  item: any;
};

const NewsGlobalSearchResultItem = ({ item, closeGlobalSearch }: NewsProps) => {
  const intl = useIntl();
  const locale = intl.locale;
  const universityToken = item?.extras?.taxonomy_university;
  const teaserProps = mapItemToTeaserProps(
    { ...item, whole_day: true },
    { locale },
    'news',
  );
  const university = useVocab('collective.taxonomy.university');

  const UniversityName = mapTokenToLabel(universityToken, university);

  return (
    <article className="result-item news-result-item">
      <div className="result-top">
        <GlobalSearchBreadcrumbs
          item={item}
          closeGlobalSearch={closeGlobalSearch}
        />
        <div className="result-type">
          <span>
            <FormattedMessage id={mapContentTypesToLocaleId(item['@type'])} />
          </span>
        </div>
      </div>
      <Link
        to={item['@id']}
        className="summary url"
        onClick={closeGlobalSearch}
        title={item['@type']}
      >
        <div className="tileHeadline">
          {item?.extras?.highlighting_title &&
          item.extras?.highlighting_title.length > 0 ? (
            <span
              className="title"
              dangerouslySetInnerHTML={{
                __html: item.extras.highlighting_title,
              }}
            />
          ) : (
            <span className="title">{item.title}</span>
          )}
        </div>
        <div className="tileBody">
          {item?.extras?.highlighting &&
          item.extras?.highlighting.length > 0 ? (
            <span
              className="itemDescription"
              dangerouslySetInnerHTML={{
                __html: item.extras.highlighting,
              }}
            />
          ) : (
            <span className="itemDescription">{item.description}</span>
          )}
          <span className="additional-desc">
            {UniversityName.label && `${UniversityName.label} | `}
            {processDateAndLocation(teaserProps.dateAndLocation)}
          </span>
        </div>
      </Link>
    </article>
  );
};

export default NewsGlobalSearchResultItem;
